'use client'
import React, { HTMLAttributes, ReactElement, useEffect } from 'react'
import { LayoutBottomPaneType } from './types-and-constants/LayoutPaneTypesAndConstants'
import { useLayoutContext } from '../../../../providers/layout-provider'
import { getRetainBehaviorModifierForPane } from '../helpers/get-retain-behavior-for-pane'
import { Retain } from '../../../atoms/Retain/Retain'
import { RetainBehaviorModifier } from '../../../atoms/Retain/constants/modifiers'

interface Props extends Omit<HTMLAttributes<HTMLDivElement>, 'className'> {
    paneType: LayoutBottomPaneType
    children?: ReactElement | ReactElement[]
    customRetainBehaviorModifier?: RetainBehaviorModifier
}

/**
 * @deprecated Prefer LayoutBottomPaneRSC
 * */
export const LayoutBottomPane = ({
    paneType,
    children,
    customRetainBehaviorModifier,
    ...props
}: Props): JSX.Element => {
    const layoutContext = useLayoutContext()
    const { bottomPaneState, setBottomPaneState } = layoutContext

    if (!paneType && !bottomPaneState.paneType) {
        console.error('LayoutBottomPane must be defined for the Layout to read it.')
    }

    useEffect(() => {
        if (!!paneType) {
            setBottomPaneState({ ...bottomPaneState, paneType })
        }
    }, [paneType])

    const bottomPaneClasses = [
        'o-layout__bottom-pane',
        (bottomPaneState.paneType ?? paneType) === LayoutBottomPaneType.BOTTOM_PANE_FIXED &&
        'o-layout__bottom-pane--fixed',
        (bottomPaneState.paneType ?? paneType) === LayoutBottomPaneType.BOTTOM_PANE_STICKY &&
        'o-layout__bottom-pane--sticky',
    ]
        .filter((i) => !!i)
        .join(' ')

    return (
        <div {...props} className={bottomPaneClasses}>
            <Retain
                behaviorModifiers={[
                    customRetainBehaviorModifier ?? getRetainBehaviorModifierForPane(paneType, layoutContext),
                ]}
                className="h-full"
                behaviorOnly
            >
                {bottomPaneState.children ?? children ?? <></>}
            </Retain>
        </div>
    )
}
